import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core'
import {FormGroup} from '@angular/forms'
import {from, Observable} from 'rxjs'
import {concatMap, last, scan, tap} from 'rxjs/operators'

@Component({
  selector: 'dmmp-form-file',
  templateUrl: './file.component.html',
})

export class FileComponent implements OnInit, OnChanges {
  @Input() field: any
  @Input() identifier: string
  @Input() arrayFilesReduxTemp: any
  @Input() group: FormGroup
  @Input() sizeFilePermitted = 10485760
  @Input() numberFilesPermitted = 3
  @Output() arrayFilesRedux = new EventEmitter()
  @Output() arrayFilesAllRedux = new EventEmitter()
  @Output() changeFile = new EventEmitter()
  accept = ''
  classDisabled = ''
  arrayFiles = []
  arrayFilesEnd = []

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.arrayFilesReduxTemp?.currentValue) {
      this.addArrayObjectEnd(changes?.arrayFilesReduxTemp?.currentValue)
      this.arrayFiles = changes?.arrayFilesReduxTemp?.currentValue
    }
  }

  ngOnInit() {
    if (this.field?.validations?.regularExpressions && this.field?.validations?.regularExpressions?.length > 0) {
      this.field?.validations?.regularExpressions?.forEach(res => {
        this.accept = `${this.accept}, ${res?.expression}`
      })
    }
  }

  reset(event) {
    event.target.value = ''
  }


  onFilesChanged(event) {
    const files = event?.target?.files
    if (files?.length > 0) {
      from(files)
        .pipe(
          concatMap((file: File) => this.obsReaderFile(file)),
          scan((acc, value) => [...acc, value], []),
          last(),
          tap(it => {
            this.arrayFiles = this.arrayFiles?.filter(
              (arrayFiles, index, array) =>
                index ===
                array.findIndex(
                  arrayFilesRepeat => arrayFilesRepeat?.name === arrayFiles?.name,
                ),
            )
            this.arrayFilesAllRedux.emit(this.arrayFiles)
          })
        ).subscribe()
    }
  }


  obsReaderFile(file: File): Observable<string> {
    return new Observable(obs => {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        this.arrayFiles.push({
          name: file?.name,
          type: file?.type,
          size: file?.size,
          documentBody: btoa(e.target.result),
        })
        obs.next(btoa(e.target.result) as string)
        obs.complete()
      }
      reader.readAsBinaryString(file)
    })
  }

  addArrayObjectEnd(files) {
    this.arrayFilesEnd = []
    if (files?.length > 0) {
      for (const file of files) {
        if (file.size <= this.sizeFilePermitted) {
          this.field?.validations?.regularExpressions?.forEach(exp => {
            if (file?.type === exp?.expression) {
              if (this.arrayFilesEnd?.length <= this.numberFilesPermitted) {
                this.arrayFilesEnd.push({
                  subject: 'Annotation Case',
                  noteText: 'Annotation Text Case',
                  fileName: file?.name,
                  mimeType: file?.name,
                  documentBody: file?.documentBody,
                })
                if (this.arrayFilesEnd?.length === this.numberFilesPermitted) {
                  this.group.get(this.field?.name).disable()
                  this.classDisabled = 'disable'
                } else {
                  this.group.get(this.field?.name).enable()
                  this.classDisabled = ''
                }
              }
              this.arrayFilesRedux.emit(this.arrayFilesEnd)
            }
          })
        }
      }
    } else {
      this.arrayFilesRedux.emit([])
    }
  }

}
